import { ACCOMPANYING_BASES, PACKAGES, computeTotal, currentSlot } from "@/lib/mockStore";
import { cn } from "@/lib/utils";

const inr = (n) => `₹${n.toLocaleString("en-IN")}`;

const COLUMNS = [
  { slot: "regular", title: "Early Bird", sub: "Up to 15 Nov 2026" },
  { slot: "late", title: "Late Registration", sub: "From 16 Nov 2026" },
  { slot: "spot", title: "Spot Registration", sub: "At the venue" },
];

const ROWS = [
  ...PACKAGES.map((p) => ({
    id: p.id,
    label: p.label,
    bases: { regular: p.regularBase, late: p.lateBase, spot: p.spotBase },
  })),
  { id: "accompanying", label: "Accompanying Person", bases: ACCOMPANYING_BASES },
];

export const FeeTable = () => {
  const active = currentSlot();
  return (
    <div className="mt-14" data-testid="fee-table">
      <div className="text-xs font-semibold uppercase tracking-[0.22em] text-apicon-green">
        Registration fees
      </div>
      <div className="mt-4 overflow-x-auto rounded-3xl border border-gray-100 shadow-sm">
        <table className="w-full min-w-[640px] text-left text-sm">
          <thead className="bg-apicon-navy text-white">
            <tr>
              <th className="px-5 py-4 font-display font-semibold">Category</th>
              {COLUMNS.map((c) => (
                <th key={c.slot} className="px-5 py-4" data-testid={`fee-col-${c.slot}`}>
                  <div className="flex items-center gap-2 font-display font-semibold">
                    {c.title}
                    {c.slot === active && (
                      <span className="rounded-full bg-apicon-gold px-2 py-0.5 text-[10px] font-bold uppercase tracking-wider text-apicon-navy">
                        Now
                      </span>
                    )}
                  </div>
                  <div className="text-xs font-normal text-white/70">{c.sub}</div>
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {ROWS.map((r, i) => (
              <tr key={r.id} className={i % 2 ? "bg-apicon-mist/40" : "bg-white"} data-testid={`fee-row-${r.id}`}>
                <td className="px-5 py-4 font-medium text-apicon-navy">{r.label}</td>
                {COLUMNS.map((c) => (
                  <td
                    key={c.slot}
                    className={cn("px-5 py-4", c.slot === active && "bg-apicon-gold/10")}
                  >
                    <div className="font-display text-base font-bold text-apicon-navy">
                      {inr(computeTotal(r.bases[c.slot]))}
                    </div>
                    <div className="text-xs text-gray-500">{inr(r.bases[c.slot])} + 18% GST</div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <p className="mt-3 text-xs text-gray-500">
        Early-bird pricing ends 15 November 2026 at 11:59 PM IST. Prices update automatically at checkout.
      </p>
    </div>
  );
};
